import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import QuarterRange from "./QuarterRange";
import SingleDay from "./SingleDay";
import CustomRange from "./CustomRange";
import FutureDaysAndEarlier from "./FutureDaysAndEarlier";
import RollingDates from "./RollingDates";
import {
  DATE_TERM_3_YEARS_TO_NEXT_DAYS,
  DATE_TERM_CUSTOM_RANGE,
  DATE_TERM_FISCAL_QUARTER_RANGE,
  DATE_TERM_MONTH_TO_MONTH,
  DATE_TERM_SINGLE_DAY,
  rollingList,
} from "../../../utils/constants/constants";
import MonthToMonth from "./MonthToMonth";

const Container = styled.div(
  ({ theme }) => `
    margin-top: 24px;
    left: 6px;
    & > span {
        color: ${theme.menuPrimary ? theme.textOnPrimary : theme.text.primary};
        padding: 0px 12px;
        font-size: 0.7em;
        margin-left: 10px;
        text-transform: uppercase;

        &:hover {
            text-decoration: underline;
            cursor: pointer;
        }
    }
`
);

export default function CustomDateFilters(props) {
  const theme = useTheme();
  const rollingDates = props.dateFiltersConfig?.rollingDates ?? {};

  // Helper function to create reusable date filter components
  const createRollingDateElement = ({ type, toDateType, label }) => (
    <RollingDates
      {...props}
      selectProps={type ? props.selectProps : null}
      type={type}
      recentMonthsChange={props.recentMonthsChange}
      toDateType={toDateType}
      label={label}
      defaultRollingDate={rollingDates[toDateType]}
      defaultRollingDateCount={rollingDates[toDateType]?.count ?? 1}
      overPrimary={theme.menuPrimary}
    />
  );

  // Predefined date filter components
  const defaultDateFilters = {
    [DATE_TERM_SINGLE_DAY]: (
      <SingleDay Container={Container} theme={theme} {...props} />
    ),
    [DATE_TERM_CUSTOM_RANGE]: (
      <Container>
        <CustomRange {...props} />
      </Container>
    ),
    [DATE_TERM_FISCAL_QUARTER_RANGE]: <QuarterRange {...props} />,
    [DATE_TERM_3_YEARS_TO_NEXT_DAYS]: (
      <Container>
        <FutureDaysAndEarlier {...props} />
      </Container>
    ),
    [DATE_TERM_MONTH_TO_MONTH]: <MonthToMonth {...props} />,
  };

  // Adding rolling list items dynamically
  const customElements = rollingList.reduce((acc, curr) => {
    acc[curr.key] = createRollingDateElement(curr);
    return acc;
  }, defaultDateFilters);

  // Return the matching date filter component or null if not found
  return customElements[props.dateType] ?? null;
}
